<div>
    <app-header></app-header>
    <div class="vh-100">
        <div class="container h-100">
            <div class="d-flex h-100 justify-content-center align-items-center">
                <div class="jumbotron text-center">
                    <h1 class="display-1">404</h1>
                    <p class="lead"></p>
                    <hr class="my-4">
                    <button class="btn btn-link" (click)="goHome()">Regresar</button>
                </div>
            </div>
        </div>
    </div>
</div>